var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 4"}},[_c('circle',{attrs:{"cx":"2","cy":"2","r":"2"}}),_c('circle',{attrs:{"cx":"9","cy":"2","r":"2"}}),_c('circle',{attrs:{"cx":"16","cy":"2","r":"2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }